























import { Component, Mixins } from "vue-property-decorator";
import { IContentSource } from "../../../../../domain/drawing";
import { DialogMixin, PdfStyleDrawableMixin } from "../../../../system/mixins";
import { PdfViewer } from "../../../../system/viewers";

@Component({
  components: {
    PdfViewer,
  }
})
export default class DebugPdfPreviewDialog extends Mixins(DialogMixin, PdfStyleDrawableMixin) {
  data(): any {
    return {
      content: null,
    };
  }
  content: IContentSource;

  get source(): string {
    return this.content
      ? this.content.source
      : null;
  }

  get isLoading(): boolean {
    return !this.source;
  }

  async show(content: IContentSource): Promise<void> {
    return this.showModal(async () => {
      this.content = content;
      await this.waitHidden();
    });
  }
}
